var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "simple-form flex col-3" }, [
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "form-value",
              attrs: { title: _vm.voucher.sellerName }
            },
            [_vm._v(_vm._s(_vm.voucher.sellerName))]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(1),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value", attrs: { title: _vm.voucher.no } },
            [_vm._v(_vm._s(_vm.voucher.no))]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(2),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "form-value",
              attrs: { title: _vm.voucher.fstPartyHtBh }
            },
            [_vm._v(_vm._s(_vm.voucher.fstPartyHtBh))]
          )
        ])
      ]),
      _vm._v(" "),
      _vm.tradeFlag == "goods"
        ? _c("div", { staticClass: "simple-form flex col-3" }, [
            _c("div", { staticClass: "form-group center" }, [
              _vm._m(3),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "form-value",
                  attrs: { title: _vm.voucher.contractGoodsCount }
                },
                [_vm._v(_vm._s(_vm.voucher.contractGoodsCount || 0))]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _vm._m(4),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "form-value",
                  attrs: { title: _vm.voucher.recvGoodsCount }
                },
                [_vm._v(_vm._s(_vm.voucher.recvGoodsCount || 0))]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _vm._m(5),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "form-value",
                  attrs: { title: _vm.voucher.returnGoodsCount }
                },
                [_vm._v(_vm._s(_vm.voucher.returnGoodsCount || 0))]
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.tradeFlag == "integ" || _vm.tradeFlag == "servc"
        ? _c("div", { staticClass: "simple-form flex col-3" }, [
            _c("div", { staticClass: "form-group center" }, [
              _vm._m(6),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "form-value",
                  attrs: { title: _vm.voucher.contractServcCount }
                },
                [_vm._v(_vm._s(_vm.voucher.contractServcCount || 0))]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _vm._m(7),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "form-value",
                  attrs: { title: _vm.voucher.servcFinishedCount }
                },
                [_vm._v(_vm._s(_vm.voucher.servcFinishedCount || 0))]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _vm._m(8),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "form-value",
                  attrs: { title: _vm.voucher.rspTimeMiAvg }
                },
                [_vm._v(_vm._s(_vm.voucher.rspTimeMiAvg || 0))]
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "simple-form flex col-3" }, [
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(9),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "form-value",
              attrs: { title: _vm.voucher.estmtAmount }
            },
            [_vm._v(_vm._s((_vm.voucher.estmtAmount || 0).toFixed(2)))]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(10),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "form-value",
              attrs: { title: _vm.voucher.totalZxAmount }
            },
            [_vm._v(_vm._s((_vm.voucher.totalZxAmount || 0).toFixed(2)))]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(11),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "form-value",
              attrs: { title: _vm.voucher.paidAmount }
            },
            [_vm._v(_vm._s((_vm.voucher.paidAmount || 0).toFixed(2)))]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(12),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "form-value",
              attrs: { title: _vm.voucher.applingPayAmount }
            },
            [_vm._v(_vm._s((_vm.voucher.applingPayAmount || 0).toFixed(2)))]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(13),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "form-value",
              attrs: { title: _vm.voucher.refundedAmount }
            },
            [_vm._v(_vm._s((_vm.voucher.refundedAmount || 0).toFixed(2)))]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(14),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "form-value",
              attrs: { title: _vm.voucher.trackPhaseName }
            },
            [_vm._v(_vm._s(_vm.voucher.trackPhaseName))]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(15),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _vm.voucher.deliverFinished
              ? _c("span", [_vm._v("是")])
              : _c("span", [_vm._v("否")])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(16),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _vm.voucher.payFinished
              ? _c("span", [_vm._v("是")])
              : _c("span", [_vm._v("否")])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(17),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "form-value",
              attrs: { title: _vm.voucher.createTime }
            },
            [_vm._v(_vm._s(_vm.voucher.createTime))]
          )
        ])
      ]),
      _vm._v(" "),
      _vm._l(_vm.voucher.trackPhaseList, function(trackPhase) {
        return _c("div", [
          _c("div", { staticClass: "content-caption dashed" }, [
            _c("span", [_vm._v(_vm._s(trackPhase.name))])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "simple-form flex col-3" },
            [
              _vm.tradeFlag == "goods" || _vm.tradeFlag == "integ"
                ? [
                    _c("div", { staticClass: "form-group center" }, [
                      _vm._m(18, true),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "form-value",
                          attrs: { title: trackPhase.goodsDeliverCount }
                        },
                        [_vm._v(_vm._s(trackPhase.goodsDeliverCount || 0))]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group center" }, [
                      _vm._m(19, true),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "form-value",
                          attrs: { title: trackPhase.estmtGoodsCount }
                        },
                        [_vm._v(_vm._s(trackPhase.estmtGoodsCount || 0))]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group center" }, [
                      _vm._m(20, true),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "form-value",
                          attrs: { title: trackPhase.recvGoodsCount }
                        },
                        [_vm._v(_vm._s(trackPhase.recvGoodsCount || 0))]
                      )
                    ])
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.tradeFlag == "integ" || _vm.tradeFlag == "servc"
                ? [
                    _vm.tradeFlag == "servc"
                      ? [
                          _c("div", { staticClass: "form-group center" }, [
                            _vm._m(21, true),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "form-value",
                                attrs: { title: trackPhase.goodsDeliverCount }
                              },
                              [
                                _vm._v(
                                  _vm._s(trackPhase.goodsDeliverCount || 0)
                                )
                              ]
                            )
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group center" }, [
                      _vm._m(22, true),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "form-value",
                          attrs: { title: trackPhase.servcCount }
                        },
                        [_vm._v(_vm._s(trackPhase.servcCount || 0))]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group center" }, [
                      _vm._m(23, true),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "form-value",
                          attrs: { title: trackPhase.servcFinishedCount }
                        },
                        [_vm._v(_vm._s(trackPhase.servcFinishedCount || 0))]
                      )
                    ])
                  ]
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "simple-form flex col-3" }, [
            _c("div", { staticClass: "form-group center" }, [
              _vm._m(24, true),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "form-value",
                  attrs: { title: trackPhase.amountPay }
                },
                [_vm._v(_vm._s((trackPhase.amountPay || 0).toFixed(2)))]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _vm._m(25, true),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "form-value",
                  attrs: { title: trackPhase.paidAmount }
                },
                [_vm._v(_vm._s((trackPhase.paidAmount || 0).toFixed(2)))]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _vm._m(26, true),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "form-value",
                  attrs: { title: trackPhase.refundedAmount }
                },
                [_vm._v(_vm._s((trackPhase.refundedAmount || 0).toFixed(2)))]
              )
            ])
          ])
        ])
      })
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("供方名称")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("交易单号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("自用合同编号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("合同商品总数量")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("已收货数量")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("已退货数量")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("合同服务总次数")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("已完成次数")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("响应平均时长(分钟)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("预计交易总金额(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("累计订单金额(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("实际付款金额(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("申请中金额(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("已退款金额(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("所处合同阶段")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("合同是否交付完成")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("合同是否支付完成")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("交易创建时间")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("预计阶段商品总数量")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("阶段商品总数量")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("阶段已收货数量")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("预计阶段服务总次数")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("阶段服务总次数")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("阶段已完成次数")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("阶段应付金额(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("阶段已付金额(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("阶段已退金额(元)")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-521e21b6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-521e21b6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/tradeVoucher/TradeDetail.vue
// module id = 2805
// module chunks = 0